import { memo } from "react";
import { NavigationButton } from "src/components/elements/button/NavigationButton";
import { AuIcon } from "src/components/elements/icon/AuIcon";
import { MypageSectionTitle } from "../mypageSectionTitle";
import styles from "./styles.module.scss";

export const ConnectIdsBody = memo(() => {
  return (
    <div className={styles.bodyContainer}>
      <MypageSectionTitle>ID連携</MypageSectionTitle>

      <div className={styles.listContainer}>
        <NavigationButton href="connectIds/auId">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <AuIcon /> au ID / Pontaポイント連携
          </div>
        </NavigationButton>
      </div>
    </div>
  );
});
